"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.quickActions = exports["default"] = exports.Trash = exports.Done = exports.DiscardDraft = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _classnames = _interopRequireDefault(require("classnames"));
var _Check = _interopRequireDefault(require("@material-ui/icons/Check"));
var _Delete = _interopRequireDefault(require("@material-ui/icons/Delete"));
var _Tooltip = _interopRequireDefault(require("../Tooltip"));
var threadActions = _interopRequireWildcard(require("../ThreadListItem/thread-actions"));
var _excluded = ["className", "children", "title", "noTooltip"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var quickActions = exports.quickActions = {
  archive: threadActions.archive.name,
  trash: threadActions.trash.name,
  discardDraft: threadActions.discardDraft.name
};
var QuickAction = function QuickAction(_ref) {
  var className = _ref.className,
    children = _ref.children,
    title = _ref.title,
    _ref$noTooltip = _ref.noTooltip,
    noTooltip = _ref$noTooltip === void 0 ? false : _ref$noTooltip,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    title: noTooltip ? null : title
  }, /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, props, {
    className: (0, _classnames["default"])('h-12 w-12 rounded-full flex items-center justify-center', 'text-white shadow', className)
  }), children));
};
var Done = exports.Done = function Done(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(QuickAction, (0, _extends2["default"])({}, props, {
    className: "bg-green",
    title: t('thread.actions.archive')
  }), /*#__PURE__*/_react["default"].createElement(_Check["default"], null));
};
var DiscardDraft = exports.DiscardDraft = function DiscardDraft(props) {
  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation2.t;
  return /*#__PURE__*/_react["default"].createElement(QuickAction, (0, _extends2["default"])({}, props, {
    className: "bg-red",
    title: t('thread.actions.discardDraft')
  }), /*#__PURE__*/_react["default"].createElement(_Delete["default"], null));
};
var Trash = exports.Trash = function Trash(props) {
  var _useTranslation3 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation3.t;
  return /*#__PURE__*/_react["default"].createElement(QuickAction, (0, _extends2["default"])({}, props, {
    className: "bg-red",
    title: t('thread.actions.trash')
  }), /*#__PURE__*/_react["default"].createElement(_Delete["default"], null));
};
var _default = exports["default"] = QuickAction;
//# sourceMappingURL=index.js.map